import React from "react";

export interface ConfirmPurchaseModalProps {
  open: boolean;
  productName: string;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
  /** When true, confirm is in progress (disables actions). */
  isSubmitting?: boolean;
}

const ConfirmPurchaseModal: React.FC<ConfirmPurchaseModalProps> = ({
  open,
  productName,
  onConfirm,
  onCancel,
  isSubmitting = false,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-[2px]">
      <div
        className="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-xl sm:p-8"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-purchase-title"
      >
        <h2
          id="confirm-purchase-title"
          className="text-lg font-bold text-gray-900 sm:text-xl"
        >
          Confirm Purchase
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-gray-600 sm:text-base">
          Have you completed the procurement for{" "}
          <span className="font-semibold text-gray-800">{productName}</span>?
          This will remove it from the pending list.
        </p>
        <div className="mt-8 flex flex-col-reverse gap-3 sm:flex-row sm:items-stretch sm:gap-4">
          <button
            type="button"
            onClick={() => void onConfirm()}
            disabled={isSubmitting}
            className="w-full flex-1 rounded-lg bg-green-700 px-5 py-3 text-center text-sm font-semibold text-white shadow-sm hover:bg-green-800 transition-colors disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isSubmitting ? "Updating…" : "Confirm Purchase"}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={isSubmitting}
            className="w-full rounded-lg border-2 border-orange-600 bg-white px-5 py-3 text-sm font-semibold text-orange-700 hover:bg-orange-50 transition-colors sm:w-auto sm:shrink-0 sm:min-w-[120px] disabled:cursor-not-allowed disabled:opacity-60"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPurchaseModal;
